<template>
  <el-text-field
    :class="compClass"
    v-model="elValue"
    :label="label"
    :tooltip="tooltip"
    :placeholder="placeholder"
    v-mask="timeMask"
    :disabled="disabled"
    :readonly="readonly"
    :required="required"
    :validateKey="validateKey"
    :hide-details="hideDetails"
    time
    :autofocus="autofocus"
  >
    <v-menu
      style="z-index: 200"
      slot="append"
      :class="classP"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :disabled="disabled"
      :readonly="readonly"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" :disabled="disabled || readonly">
          mdi-clock-time-four-outline
        </v-icon>
      </template>
      <v-time-picker
        ref="picker"
        :readonly="readonly"
        :disabled="disabled"
        format="24hr"
        scrollable
        v-model="picker"
        @click:minute="saveTime()"
      ></v-time-picker>
    </v-menu>
  </el-text-field>
</template>

<script>
export default {
  name: 'ElTimePicker',
  props: {
    classP: String,
    label: String,
    placeholder: { type: String, default: 'HH:MM' },
    tooltip: String,
    required: Boolean,
    need: Boolean,
    validateKey: String,
    hideDetails: { type: Boolean, default: true },
    value: String,
    disabled: Boolean,
    readonly: Boolean,
    autofocus: { type: Boolean, default: false },
  },
  data() {
    return {
      menu: false,
      picker: null,
    }
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
        this.checkTimeFormat(elValue)
      },
    },
    timeMask() {
      return [/[0-2]/, /\d/, ':', /[0-5]/, /\d/]
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonly
        ? 'required-input'
        : ''
    },
    compClass() {
      return `${this.classP} ${this.requiredClass} labelPatch`
    },
  },
  created() {
    //
  },
  methods: {
    saveTime() {
      this.$nextTick(() => {
        this.menu = false
        this.elValue = this.picker
        this.$refs.picker.selectingHour = true
      })
    },
    checkTimeFormat(elValue) {
      var timeformat = /^([0-1][1-9]|2[0-3]):[0-5][0-9]$/
      if (elValue.match(timeformat)) {
        this.picker = elValue
        const field = this.$validator.fields.find({ name: this.label })
        field.reset()
        this.$validator.errors.remove(field.name, field.scope)
      } else {
        this.picker = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/elements.scss';
</style>
